import { isUndefined } from 'lodash-es';

import { ChartOverlaysBorder } from '../../../core/components/overlays/ChartOverlaysBorder.js';
import { useYScales } from '../../hooks/useYScales.js';

export const TimeseriesChartOverlaysBorder = () => {
  const { left, right } = useYScales();

  return (
    <ChartOverlaysBorder
      left={!isUndefined(left)}
      right={!isUndefined(right)}
      bottom
    />
  );
};
